
import Game from "./game";
import Run from "./run";
import Space from "./frp/space";
import Stream from "./frp/stream";
import SETTINGS from 'settings'

export default function({
    server,
    construct,
    rootContainer,
    errorView,
    uiConfig,
    parent,
    uiRootContainer,
    errorDriver,
    params,
})
{
    if ( server ) SETTINGS.spec = server.loginData.spec
    
    construct = construct || params.construct
    
    window.onkeydown = e => {
        if (e.keyCode === 27 || e.keyCode === 32 || e.keyCode >= 112 && e.keyCode <= 121 ) { // F1-F10
            return false;
        }
        
        return true;
    };
    
    window.onkeyup = e => {
        if (e.keyCode === 27 || e.keyCode === 32 || e.keyCode >= 112 && e.keyCode <= 121 ) { // F1-F10
            return false;
        }
        
        return true;
    };
    
    const app = {};
    
    let needReset = true;
    parent.s( 'error' ).on( () => needReset = true )
    const $net = parent.s( 'net' )
    $net.on( () =>
    {
        if ( ! needReset ) return
        //при переинициализации этот стрим должен иметь значение false, иначе он установится в нужное значение гораздо позже инициализации
        parent.s( 'error_driver:isError' ).next(false);
        needReset = false;
        init()
    } )
    parent.s( 'child_init' ).on( init )
    //TODO: rework due to new (socket-wise) communication:
    if ( server ) {
        if ( server.space ) server.space.s( 'init' ).on( () => needReset = true )
    }
    
    if ( $net.value ) $net.next( $net.value )
    
    function init()
    {
        dispose( app );
        
        console.log( "INIT" );
        
        app.space = new Space( "root" );
        //online debugging:
        window.app_space = app.space
        
        app.gameContainer = new PIXI.Container;
        rootContainer.addChild( app.gameContainer );
        rootContainer.addChild( errorView );
        app.always_interactive_container = new PIXI.Container
        rootContainer.addChild( app.always_interactive_container )
        
        app.space.s( 'interactive' ).on( i => {
            app.gameContainer.interactive = i
            app.gameContainer.interactiveChildren = i
        } )
        
        if ( construct ) app.constructed = construct( server.loginData.spec, app.space )
        else app.constructed = {}
        if ( params.reactive ) app.constructed.reactive = params.reactive

        if (uiRootContainer) {
            app.uiContainer = new PIXI.Container;
            uiRootContainer.addChild(app.uiContainer)
        }
        
        if ( ! SETTINGS.no_default_lib ) {
            const run = Run(
                app.gameContainer,
                app.constructed,
                {
                    uiConfig,
                    spec : server.loginData.spec,
                },
                app.space,
                app.uiContainer,
                app.always_interactive_container
            );
            //online debugging:
            window.app_run = run
            
            Game(
                app.space,
                run,
                {
                    lines : server.loginData.spec.lines_array,
                    multipliers : server.loginData.spec.bets_array,
                },
                server.bonusSettings,
                server.loginData.spec
            );
        }
        
        connect(
            parent,
            app,
        )
    }
}

export function connect(
    parent,
    app,
)
{
    if ( app.constructed && app.constructed.reactive )
    {
        console.log( "Merging library structure with current game ..." );
        app.destroy = app.constructed.reactive( app.space, app.constructed, app );
        console.log( "... merged." );
    }
    
    if ( SETTINGS.dull_server_construct ) SETTINGS.dull_server_construct( app.space, server )
    
    console.time( "Apply" );
    
    app.space.apply();
    
    //glue only after the whole game model built to let different parts subscribe BEFORE state comes in:

    app.space.s( "goLobby" ).to(parent.s('goToLobby'))
    app.space.s( "goLobby" ).to( parent.s( 'error_driver:goLobby' ) )
    app.space.s( "progress_indicator" ).to( parent.s( 'error_driver:progress_indicator' ) )
    parent.s( 'error_driver:progress_indicator' ).to( app.space.s( "progress_indicator_get" ) )
    app.space.s( 'preloader_also_visible').to( parent.s( 'error_driver:preloader_also_visible' ) )
    app.space.s( "request" ).to( parent.s( 'request' ) )
    parent.s( 'pending' ).to( app.space.s( "pending" ) );
    parent.s( 'lastRequest' ).to( app.space.s( "lastRequest" ) )
    parent.s( 'error' ).to( app.space.s( "error" ) );
    glue( parent.s( 'net' ), app.space.s( "net" ) )
    glue( parent.s( 'balance_poll' ), app.space.s( "balance_poll" ) )
    glue( parent.s( 'progressive_jackpot' ), app.space.s( "progressive_jackpot" ) )
    
    parent.s( 'ticker' ).to( app.space.s( "ticker" ) )
    parent.s( 'keyboard' ).to( app.space.s( 'raw_keyboard' ) )
    if ( SETTINGS.no_default_lib ) parent.s( 'keyboard' ).to( app.space.s( 'keyboard' ) )
    
    glue( parent.s('change_screen'), app.space.s( 'change_screen' ) )
    glue( parent.s( 'resize' ), app.space.s( 'size' ) )
    
    app.space.s( 'ui:need_fullscreen' ).next( parent.s( 'need_fullscreen' ).value )
    app.space.s( 'ui:need_fullscreen' ).to( parent.s( 'need_fullscreen' ) )
    app.space.s( 'ui:landscape' ).next( parent.s( 'landscape' ).value )
    app.space.s( 'ui:landscape' ).to( parent.s( 'landscape' ) )

    //попросили по умолчанию включать звук 
    //app.space.s( 'muteSound' ).next( parent.s( 'load:postpone_sounds' ).value )
    app.space.s( 'muteSound' ).to( parent.s( 'load:postpone_sounds' ) )
    app.space.s( 'muteSound' ).next( false )

    parent.s( 'load:complete' ).to( app.space.s( 'load:complete' ) )
    app.space.s( 'load:load' ).to( parent.s( 'load:load' ) )
    glue( parent.s( 'load:loading' ), app.space.s( 'load:loading' ) )
    
    //В либе и в space'е игры есть стрим с одним и тем же названием которые хотелось бы идентичным образом связать: сообщение в один стрим передаётся не только в зависимые от этого стрима, но и в зависимые от его близнеца и наоборот. Проблема возникает когда ещё при инициализации space'а игры императивным образом отправляется сообщение в один из таких (игры) стримов: библиотечный близнец уже участвовать в propagation и никогда не обновится:
    app.space.s( 'screen_ratio' ).to( parent.s( 'screen_ratio_sink' ) )
    parent.s( 'screen_ratio_source' ).to( app.space.s( 'screen_ratio' ) )
    //if nothing to pass anyway:
    if ( app.space.s( 'screen_ratio' ).value === undefined ) app.space.s( 'screen_ratio' ).next( parent.s( 'screen_ratio_source' ).value )
    //if game set some initial value:
    else parent.s( 'screen_ratio_sink' ).next( app.space.s( 'screen_ratio' ).value )

    parent.s('show_tap_screen').filter(show => show).map(() => false).to(app.space.s('ui:isAutoplay'))

    glue( parent.s( 'tab_visibility' ), app.space.s( 'tab_visibility' ) )
    
    app.space.s( 'server_action' ).to( parent.s( 'server_action' ) )
    parent.s( 'server_result' ).to( app.space.s( 'server_result' ) )
    
    glue(
        parent.s( 'server:settings' ),
        app.space.s( 'server:settings' ),
        true,
    )
    
    app.space.s( 'no_sleep' ).to( parent.s( 'no_sleep' ) )

    // minigames
    parent.s( 'account_selection_changed' ).to( app.space.s( 'account_selection_changed' ) )
    parent.s( 'error_driver:isError' ).to( app.space.s( 'isError' ) )
    app.space.s( 'isError' ).next( parent.s( 'error_driver:isError' ).value )

    console.timeEnd( "Apply" );
    
    
    if ( ! SETTINGS.isMobile ) {
        console.log( 'Docs:' )
        app.space.print();
    }
}

export function glue( source, target, no_undefined )
{
    source.to( target )
    if ( ! no_undefined || target.value !== undefined ) target.next( source.value )
}

function dispose( app )
{
    // при перезапуске вернем все звуки назад
    sounds.muteAll(false);

    if ( app.gameContainer )
    {
        for ( const child of app.gameContainer.children )
        {
            if ( child.terminate ) child.terminate();
        }
        app.gameContainer.destroy( { children : true } );
    }

    if (app.uiContainer) {
        app.uiContainer.destroy( { children : true } );
    }

    if ( app.always_interactive_container ) app.always_interactive_container.destroy( { children : true } )
    
    if ( app.space )
    {
        app.space.clear();
    }
    
    if ( typeof app.destroy === 'function' ) app.destroy()
    
    TWEEN.removeAll();
}





// WEBPACK FOOTER //
// ./src/library/init.es6